import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=c156a594"
import script from "./AppForm.vue?vue&type=script&lang=ts"
export * from "./AppForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_css-loader@6.8.1_webpack@5_79bb117af622368260e8ed0e17206237/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports